import {ApplicationModuleBase} from '../database-models/application-module-base';
import {ModuleMasterBase} from '../database-models/module-master-base';
import {RolePermissionBase} from '../database-models/role-permission-base';
//Generated Imports
export class ApplicationModule extends ApplicationModuleBase 
{




//#region Generated Reference Properties
//#region moduleMaster Prop
moduleMaster : ModuleMasterBase;
//#endregion moduleMaster Prop
//#region rolePermissions Prop
rolePermissions : RolePermissionBase[];
//#endregion rolePermissions Prop

//#endregion Generated Reference Properties



























}